import { StepStub } from '../ai/campaignFlows';

/**
 * Persist an AI-proposed step outline into real CampaignStep rows, depth-first.
 *
 * The tree is created parent-before-children so each child can carry its parent's freshly minted id
 * (a step's `parent` FK). Every create is a full record — the generic runtime treats the write like
 * a create and 400s on a partial body — so the JSON bags and the null escape-hatch fields are always
 * sent. `createStep` is `useCampaignMutations('step').create.mutateAsync`; a stub with children whose
 * `step_kind` was left unset becomes a `group`, otherwise `content`.
 */
export async function persistStubTree(
  createStep: (payload: Record<string, any>) => Promise<any>,
  campaignId: number,
  stubs: StepStub[],
  parentId: number | null,
  startOrder: number
): Promise<void> {
  let order = startOrder;
  for (const stub of stubs) {
    const hasChildren = !!(stub.children && stub.children.length);
    const row = await createStep({
      campaign: campaignId,
      parent: parentId,
      order: order++,
      name: (stub.name || 'Untitled step').trim(),
      description: stub.description?.trim() || null,
      is_required: stub.is_required ?? true,
      track: stub.track ?? 'enablement',
      step_kind: stub.step_kind ?? (hasChildren ? 'group' : 'content'),
      journey_map: null,
      assessment: null,
      child_type: null,
      child_id: null,
      launch_url: null,
      provider: null,
      provider_config: {},
      metadata: {},
      estimated_duration_minutes: null,
    });
    if (hasChildren && row && row.id != null) {
      await persistStubTree(createStep, campaignId, stub.children as StepStub[], row.id, 0);
    }
  }
}
